import React from 'react';

// eslint-disable-next-line import/no-extraneous-dependencies
import PropTypes from 'prop-types';

import { AnimationsSettingsProvider } from '@bluefin/components';

import {
  DEFAULT_ENABLED,
  DEFAULT_PAGE_TRANSITION_SETTINGS,
} from './AnimationsSettingsContextWrapper.constants';

const propTypes = {
  children: PropTypes.node.isRequired,
  enabled: PropTypes.bool,
  pageTransition: PropTypes.shape({
    enabled: PropTypes.bool,
    transition: PropTypes.string,
    durationIn: PropTypes.number,
    durationOut: PropTypes.number,
  }),
};

const defaultProps = {
  enabled: DEFAULT_ENABLED,
  pageTransition: DEFAULT_PAGE_TRANSITION_SETTINGS,
};

export default function AnimationsSettingsContextWrapper({
  children,
  enabled,
  pageTransition: pageTransitionProp,
}) {
  const pageTransition = {
    ...DEFAULT_PAGE_TRANSITION_SETTINGS,
    ...pageTransitionProp,
  };
  const animationsSettingsContext = { enabled, pageTransition };

  return (
    <AnimationsSettingsProvider value={animationsSettingsContext}>
      {children}
    </AnimationsSettingsProvider>
  );
}

AnimationsSettingsContextWrapper.propTypes = propTypes;
AnimationsSettingsContextWrapper.defaultProps = defaultProps;
